/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ValidationMessage,
    ValidationMessageFromJSON,
    ValidationMessageFromJSONTyped,
    ValidationMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface DistributionChannelFormWarningsData
 */
export interface DistributionChannelFormWarningsData {
    /**
     * 
     * @type {ValidationMessage}
     * @memberof DistributionChannelFormWarningsData
     */
    label?: ValidationMessage;
}

export function DistributionChannelFormWarningsDataFromJSON(json: any): DistributionChannelFormWarningsData {
    return DistributionChannelFormWarningsDataFromJSONTyped(json, false);
}

export function DistributionChannelFormWarningsDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): DistributionChannelFormWarningsData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': !exists(json, 'label') ? undefined : ValidationMessageFromJSON(json['label']),
    };
}

export function DistributionChannelFormWarningsDataToJSON(value?: DistributionChannelFormWarningsData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': ValidationMessageToJSON(value.label),
    };
}


